(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalFirmRegionDialogController', AppraisalFirmRegionDialogController);

    AppraisalFirmRegionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AppraisalFirmRegion', 'AppraisalFirm', 'AppraisalFirmLocation', 'Principal'];

    function AppraisalFirmRegionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AppraisalFirmRegion, AppraisalFirm, AppraisalFirmLocation, Principal) {
        var vm = this;

        vm.appraisalFirmRegion = entity;
        vm.isAdmin = Principal.hasAnyRole(['ADMIN']);
        vm.clear = clear;
        vm.save = save;
        vm.appraisalfirms = AppraisalFirm.query({size:2000});
        vm.appraisalfirmlocations = AppraisalFirmLocation.query();

        vm.selectedFirm = null;
        vm.firmSearchText = '';
        vm.searchFirms = searchFirms;
        vm.onFirmSelected = onFirmSelected;

        if (vm.appraisalFirmRegion.appraisalFirmId) {
            vm.appraisalfirms.$promise.then(function(firms) {
                vm.selectedFirm = firms.find(function(f) {
                    return f.id === vm.appraisalFirmRegion.appraisalFirmId;
                }) || null;
            });
        }

        function searchFirms(searchText) {
            if (!searchText) {
                return vm.appraisalfirms;
            }
            var lowerSearch = searchText.toLowerCase();
            return vm.appraisalfirms.filter(function(firm) {
                return firm.name.toLowerCase().indexOf(lowerSearch) !== -1;
            });
        }

        function onFirmSelected(firm) {
            vm.appraisalFirmRegion.appraisalFirmId = firm ? firm.id : null;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.appraisalFirmRegion.id !== null) {
                AppraisalFirmRegion.update(vm.appraisalFirmRegion, onSaveSuccess, onSaveError);
            } else {
                AppraisalFirmRegion.save(vm.appraisalFirmRegion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:appraisalFirmRegionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
